import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Section } from '@scope/scope-one-ui/core';
import { PageData } from '../../types/climateStressTest';
import { OutputLoss } from './OutputLoss';
import { CountryContribution } from './CountryContribution';
import { SectorContribution } from './SectorContribution';

const sovereignChips = [
  'OUTPUT LOSS FROM PHYSICAL RISK',
  'COUNTRY CONTRIBUTION TO TEMPERATURE CHANGE',
  'SECTOR CONTRIBUTION TO TEMPERATURE CHANGE',
];

const corporateChips = ['OUTPUT LOSS FROM PHYSICAL RISK', 'CONTRIBUTION TO TEMPERATURE CHANGE'];

export const PhysicalRisk: FC<PageData> = (pageData) => {
  const { t } = useTranslation();

  return (
    <Section
      header={t('Physical risk')}
      chips={pageData.entity.isSovereign ? sovereignChips : corporateChips}
    >
      <Box display="flex" flexDirection="column" gridGap={4}>
        <OutputLoss {...pageData} />
        {pageData.entity.isSovereign && <CountryContribution {...pageData} />}
        <SectorContribution {...pageData} />
      </Box>
    </Section>
  );
};
